<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  * {
    box-sizing: border-box;
  }

  html,
  body {
    background-color: #f5f5f5;
    margin: 0;
    padding: 0;
    border: 0;
    height: 100%;
  }
  #app{
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue